module.exports = __webpack_public_path__ + "static/media/LinuxFoundation.190f1a8b.png";